
import Utils from './utils';
import * as keys from './keys';
import utils from './utils';

const FormObserver = (formRef, props) => {

    formRef.$('PPT').observe({
        key: 'value',
        call: ({ field }) => {
            const pptValue = field.value
            const planOption = formRef.$("plan-option")?.value?.id
            const incomeStartYear = formRef.$("income-benefit-payout-start-year")?.value?.id
            let incomeStartYearList = utils.getIncomeStartYearList(Number(pptValue?.label), Number(planOption))
            formRef.$("income-benefit-payout-start-year").set("extra", {
                ...formRef.$("income-benefit-payout-start-year").extra,
                optionList: incomeStartYearList,
            });
            let isSameIncomeStartYear = incomeStartYearList?.some((item) => Number(item?.id) === Number(incomeStartYear))
            if (!isSameIncomeStartYear) {
                formRef.$("income-benefit-payout-start-year").set("value", incomeStartYearList[0])
            }
            // Utils.getPremiumTermList(pptValue,formRef)
            Utils.updateBi(keys.PPT, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PT').observe({
        key: 'value',
        call: ({ field }) => {
            const ptValue = field.value.id
            let planOptionValue = formRef.$("plan-option")?.value?.id
            let planOptionList = [{ label: "Lump Sum", id: 1, }]
            if (Number(ptValue) === 100) {
                planOptionList.push({ label: "Lump Sum Plus Income", id: 2, })
            }
            formRef.$("plan-option").set("extra", {
                ...formRef.$("plan-option").extra,
                optionList: planOptionList,
            });
            let isSamePlanOption = planOptionList?.some((item) => Number(item?.id) === Number(planOptionValue))
            if (!isSamePlanOption) {
                formRef.$("plan-option").set("value", { label: "Lump Sum", id: 1, })
            }

            Utils.updateBi(keys.PT, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('payment-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            let premium = formRef.$("premium").value;
            let frequency = Number(field.value.id);

            let amount = Number(premium);
            let premiumAmount = "";
            switch (frequency) {
                case 1:
                case 5:
                    premiumAmount = "" + amount * 1;
                    break;
                case 2:
                    premiumAmount = "" + amount * 2;
                    break;
                case 3:
                    premiumAmount = "" + amount * 4;
                    break;
                case 4:
                    premiumAmount = "" + amount * 12;
                    break;
            }
            let data = {
                premium: premiumAmount,
                frequency: frequency,
            };
            Utils.updateBi(keys.FREQUENCY, data, props.data.package_id, formRef, props)
        }
    })

    formRef.$('lump-sum-benefit').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.LUMPSUM_BENEFIT, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('is-existing-customer').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.IsExistingCustomer, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('ecs-mandate-auto-debit').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.IsECSMandate, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('plan-option').observe({
        key: 'value',
        call: ({ field }) => {
            let planOption = field.value.id
            let pptList = utils.getPPTList(Number(planOption))
            let pptValue = formRef.$('PPT')?.value
            formRef.$("PPT").set("extra", {
                ...formRef.$("PPT").extra,
                optionList: pptList,
            });
            let deathbenList = utils.getDeathBenefitList(Number(planOption))
            formRef.$('death-benefit-option').set("extra", {
                ...formRef.$('death-benefit-option').extra,
                optionList: deathbenList,
            });
            let incomeDurationList = utils.getIncomeDurationList(Number(planOption))
            formRef.$('income-duration').set("extra", {
                ...formRef.$('income-duration').extra,
                optionList: incomeDurationList,
            });
            let incomeStartYearList = utils.getIncomeStartYearList(Number(pptValue?.label), Number(planOption))
            formRef.$("income-benefit-payout-start-year").set("extra", {
                ...formRef.$("income-benefit-payout-start-year").extra,
                optionList: incomeStartYearList,
            });

            if (Number(planOption) === 1) {
                formRef.$('income-benefit-pay-out-frequency').set('disabled', true)
                formRef.$('income-benefit-payout-start-year').set('disabled', true)
                formRef.$('income-duration').set('disabled', true)
                formRef.$('PT').set('disabled', false)
                formRef.$('PT').set('value', { id: 30, label: 30 })

                formRef.$('income-benefit-pay-out-frequency').set('value', "")
                formRef.$('income-benefit-payout-start-year').set('value', "")
                formRef.$('income-duration').set('value', "")
            } else {
                formRef.$('income-benefit-pay-out-frequency').set('disabled', false)
                formRef.$('income-benefit-payout-start-year').set('disabled', false)
                formRef.$('income-duration').set('disabled', false)
                formRef.$('PT').set('disabled', true)

                formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Annual', id: '24' })
                formRef.$('income-benefit-payout-start-year').set('value', { label: pptValue?.id, id: Number(pptValue?.id) + 1 })
                formRef.$('income-duration').set('value', { label: '20', id: '29' })
            }
            Utils.updateBi(keys.PlanOption, field.value.id, props.data.package_id, formRef, props)
        }
    })



    formRef.$('income-benefit-pay-out-frequency').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.INCOME_BENEFIT_PAYOUT_FREQUENCY, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-duration').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeDuration = field.value
            let incomeStartYear = formRef.$('income-benefit-payout-start-year').value
            let planOption = formRef.$('plan-option').value?.id
            if (Number(planOption) === 2) {
                let value = Number(incomeDuration?.label) + Number(incomeStartYear?.label) - 1
                formRef.$('PT').set("value", { id: 100, label: value })
            }

            Utils.updateBi(keys.IncomeDuration, field.value.id, props.data.package_id, formRef, props)
        }
    })

    formRef.$('income-benefit-payout-start-year').observe({
        key: 'value',
        call: ({ field }) => {
            let incomeStartYear = field.value
            let incomeDuration = formRef.$('income-duration').value
            let planOption = formRef.$('plan-option').value?.id
            if (Number(planOption) === 2) {
                let value = Number(incomeDuration?.label) + Number(incomeStartYear?.label) - 1
                formRef.$('PT').set("value", { id: 100, label: value })
            }

            Utils.updateBi(keys.IncomeBenefitPayoutStartYear, field.value.id, props.data.package_id, formRef, props)
        }
    })






    formRef.$('ADB').observe({
        key: 'value',
        call: ({ field }) => {
            let adbValue = formRef.$('ADB-dropdown').value
            Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('ATPDRider').observe({
        key: 'value',
        call: ({ field }) => {
            let atpdValue = formRef.$('ATPDRider-dropdown').value
            Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.package_id, formRef, props)
        }
    })

    formRef.$('CriticalIllnessRider').observe({
        key: 'value',
        call: ({ field }) => {
            let criticalIllness = formRef.$('CriticalIllnessRider-dropdown').value
            Utils.updateBi(keys.Critical_ILLNESS_RIDER, criticalIllness, props.data.package_id, formRef, props)
        }
    })


    formRef.$('HospitalityCashBenefitRider').observe({
        key: 'value',
        call: ({ field }) => {
            let hospitalityCashBenefit = formRef.$('HospitalityCashBenefitRider-dropdown').value
            Utils.updateBi(keys.HOSPITALITY_CASH_BENEFIT_RIDER, hospitalityCashBenefit, props.data.package_id, formRef, props)
        }
    })

    formRef.$('PayorWaiverBenefitRider-dropdown').observe({
        key: 'value',
        call: ({ field }) => {
            Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.package_id, formRef, props)
        }
    })

    // formRef.$('family-income-benefit-option-dropdown').observe({
    //     key: 'value',
    //     call: ({ field }) => {
    //         if (formRef.$('family-income-benefit-option').value) {
    //             Utils.updateBi(keys.FAMILY_BENEFIT_INCOME_OPTION, field.value.id, props.data.package_id, formRef, props)
    //         }
    //     }
    // })

}

export default FormObserver